import type { UserForCheckoutMutation, UserForCheckoutParams } from '@/generated/hasura';
import { userForCheckout } from '@/graphql/hasura/auth/user-for-checkout';
import { initializeApollo } from '@/lib/apollo/apollo-client';
import { AlterError } from '@/lib/error';

const context = { clientName: 'rapptr' };

export type UserForCheckoutParamsTokenSet = NonNullable<
  NonNullable<UserForCheckoutMutation['userForCheckout']>['tokenSet']
>;

export const createUserForCheckout = async (
  userForCheckoutParams: UserForCheckoutParams
): Promise<UserForCheckoutParamsTokenSet> => {
  const apolloClient = initializeApollo();
  const { data } = await apolloClient.mutate<UserForCheckoutMutation>({
    mutation: userForCheckout,
    context,
    variables: {
      userForCheckoutParams,
    },
  });
  if (data?.userForCheckout?.alterError) {
    throw new AlterError(data.userForCheckout.alterError);
  }
  const tokenSet = data?.userForCheckout?.tokenSet;
  if (!tokenSet) {
    throw new Error('TOKEN_SET_NOT_DEFINED');
  }
  return tokenSet;
};
